// search functionality for text input on array,
// it will filter the array containing the substring of entered search terms
export const searchFilter = (searchKey, obj) => {
  const result = {};

  for (const key in obj) {
    if (key.includes(searchKey)) {
      result[key] = obj[key];
    }
  }

  return result; // Returns an object with matching keys or an empty object if no matches
};

// formating pdf chunks for highlight.
export const phdSearchFormater = (string) => {
  let result = string
    .replace(/ +\n+/g, "") // Remove spaces before newlines, and the newlines
    .replace(/  +/g, " ") // Then replace double spaces with a single space
    .replace(/\n+/g, "") // Finally, remove any remaining newline characters
    .replace(/ \./g, ".") // Remove space before any period, for cleanup
    // .replace(/\.  /g, ".") // Remove space before any period, for cleanup
    // .replace(/\. /g, ".") // Remove space before any period, for cleanup
    .replace(/^\./, '').replace(/\.$/, '')// replace 

  return result.substring(0, 10);; // Returns an object with matching keys or an empty object if no matches
}



export function generateChartData(jsonData1, jsonData2) {
  // Parse the JSON data
  const data1 = JSON.parse(jsonData1);
  const data2 = JSON.parse(jsonData2);


  // Extract the years and corresponding values
  const labels = Object.keys(data1).map(date => date.slice(0, 4));
  const values1 = Object.values(data1);
  const values2 = Object.values(data2);

  // Create the chart data object
  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Benchmark',
        data: values1,
        backgroundColor: 'rgba(255, 99, 132, 0.7)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      },
      {
        label: 'Portfolio',
        data: values2,
        backgroundColor: 'rgba(54, 162, 235, 0.7)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  return chartData;
}


const getLastDayOfMonth = (year, month) => {
  if (month === 2) {
      // Check for leap year
      return new Date(year, 1, 29).getMonth() === 1 ? 29 : 28;
  } else if ([4, 6, 9, 11].includes(month)) {
      return 30;
  } else {
      return 31;
  }
};

export function generateMatrixData (jsonData)  {
  const data = JSON.parse(jsonData);
  const years = Object.keys(data).reduce((years, date) => {
      const year = new Date(date).getFullYear();
      if (!years.includes(year)) years.push(year);
      return years;
  }, []);
  years.sort();

  const matrixData = years.map(year => {
      const rowData = [];
      for (let month = 1; month <= 12; month++) {
          const lastDayOfMonth = getLastDayOfMonth(year, month);
          const isoDateString = `${year}-${String(month).padStart(2, '0')}-${String(lastDayOfMonth).padStart(2, '0')}T00:00:00`;
          const value = data[isoDateString] !== undefined ? Number(data[isoDateString].toFixed(2)) : null;
          rowData.push(value);
      }
      return rowData;
  });

  return matrixData;
};
